import React, { Component } from "react";
import Headroom from "react-headroom";
import Navigation from "../screens/Navigation.jsx";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
// import { IconButton } from "@material-ui/core";
// import { MdEdit, MdDelete, MdOpenInNew, MdComment } from "react-icons/md";
import io from "socket.io-client";
// import { IoMdCreate, IoMdTrash } from "react-icons/io";
// import { MdAddCircle, MdWork, MdBook, } from "react-icons/md";
// import KatexMarkdown from "./Markdown"
import axios from "axios"
// import { Modal, Row } from "react-bootstrap";
// import { Input } from "@material-ui/core";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/es';

export default class CreateNote extends Component {
  state = {
    showModal: false,
    title: "",
    theme: "",
    comment: "",
    calification: "",
    curse: this.props.match.params.idcurse,
    likes: "",
    fecha: new Date(),
    zz: [],
    _id: "",
    files: "",
    submit: "",
    editing: false,
    option: false,
  };

  // open = () => this.setState({ showModal: true });
  // close = () => this.setState({ showModal: false });

  getNotes = async () => {
    await axios.get(`${process.env.REACT_APP_API_URL}/lands/news/` + this.props.match.params.idcurse)
      .then(() => {
        toast.dark("Tema creado correctamente")
      })
      .catch((error) => { console.log("ERROR", error.response) });
    // toast.dark("Procesado correctamente")
  };

  componentWillUnmount() {
    // this.getNotes()
    // this.socket.disconnect();
  }

  async componentDidMount() {
    document.title = `History ${process.env.REACT_APP_URL}`
    this.getNotes()
    // this.socket = io(`${process.env.REACT_APP_URL}`)
    // this.socket.emit('forocurse', this.props.match.params.idcurse)
    // this.socket.emit("notes", this.props.match.params.idcurse)
    // this.socket.on("forum", (ww) => {
    //   console.log(ww, "newww")
    //   this.setState({ zz: ww });
    // })
  }

  cretetheme = async (curseId) => {
    this.setState({ submit: "Crear tema", option: true, });
  }

  updatetheme = async (id, theme, title) => {
    console.log(id, theme, title);
    this.setState({ editing: true, option: true, submit: "Actualizar tema", _id: id, theme, title });
  }

  render() {
    return (
      <>
        <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false} />
        <Headroom>
          <Navigation />
        </Headroom>

        <div className="container p-1 my-3">

          <CKEditor editor={ClassicEditor} config={{
            language: 'es',
            toolbar: ["math", "|", "undo", "redo", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "indent", "outdent", "|", "imageUpload", "blockQuote", "insertTable", "mediaEmbed", "heading"]
          }} data={this.state.comment} onChange={(event, editor) => {
            //wwWw(editor.getData())
            //timeNow()
          }} onReady={editor => {
            console.log('Editor is ready to use!', editor)
            //wwWw(editor.getData())
          }}
          />
        </div>
      </>
    );
  }
}
